import Chip from '@mui/material/Chip';
import clsx from 'clsx';

import { CLAUSE_CHIP_CLASS_NAME } from './clause-chip-class-name.js';

export interface UnresolvedClauseChipProps {
	/** The citation text as written. */
	label: string;
	/** Adds a dashed border to show the clause could not be found. Leave unset while it is still loading. */
	failed?: boolean;
	className?: string;
}

/**
 * A chip for a citation whose clause is still loading or could not be found. It looks like a clause chip
 * but has no tooltip, since there is no clause text to show.
 *
 * @param props - {@link UnresolvedClauseChipProps}.
 * @returns The chip element.
 */
export function UnresolvedClauseChip({ label, failed = false, className }: UnresolvedClauseChipProps) {
	return (
		<Chip
			size='small'
			label={label}
			variant='outlined'
			color='gray'
			className={clsx(CLAUSE_CHIP_CLASS_NAME, failed && 'border-dashed', className)}
		/>
	);
}
